import React from 'react';
import Entry from '../../components/Entry';
import RawEntry from '../../components/entryconfigType';
import '../../Default.css';
import { Routes, Route } from "react-router-dom";
import DayRender from './DayRender';

import readings_file from "./readings.json"
import Readings from './readingsType';
const readings: Readings[] = readings_file as any;



const menuItems: RawEntry[] = readings.map((entry,index) =>
  {
    return {
      link: `./${index}`,
      text: entry.day
    } as RawEntry
  }
)


function ReadingMenu(){
  return (
    <>
        <div className="page-title">
          Czytania
        </div>
        <div className="navigation-wraper">
          <nav className='small-nav-bar navigation-bar'>
            {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
          </nav>
        </div>
        
    </>
  )
}

function Reading() {
    return (
      <>
          <Routes>
            <Route path='/' element={ReadingMenu()}></Route>
            {readings.map((entry,index) => 
              <Route path={`/${index}/*`} key={index.toString()} element={DayRender(entry)}/>
            )}
          </Routes>
      </>
    );
}

export default Reading;